import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import i18nStore from "../../../../i18n/store";
import filterStore from "../filters/filtersStore";
import { ParamType } from "../../enums";


const useMuiCalculationsDamageParamsColDefs = (): GridColDef[] => {
    const translations = i18nStore.getTranslations;
    const [colDefs, setColDefs] = useState<GridColDef[]>([]);

    useEffect(() => {
        let newColDefs: GridColDef[] = [];

        if (filterStore.getDamageParamsValueTypes.find(vt => vt === ParamType.Current.name)) {
            newColDefs.push(
                {
                    field: "I1",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>1</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "I2",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>2</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "I0",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>0</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_1",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>1</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_2",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>2</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_0",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>0</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Ia",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>a</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Ib",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>b</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Ic",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>c</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_a",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>a</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_b",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>b</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_c",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>c</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
            );
        }

        if (filterStore.getDamageParamsValueTypes.find(vt => vt === ParamType.Resistance.name)) {
            newColDefs.push(
                {
                    field: "R1",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>1</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "X1",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>1</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "R2",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>2</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "X2",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>2</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "R0",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>0</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "X0",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>0</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "R",
                    type: 'number',
                    renderHeader: () => (<span>R, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "X",
                    type: 'number',
                    renderHeader: () => (<span>X, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
            );
        }

        setColDefs(newColDefs);
    }, [i18nStore.getCurrentLanguageCode, filterStore.getDamageParamsValueTypes]);

    return colDefs;
}


export default useMuiCalculationsDamageParamsColDefs;
